import * as Sentry from '@sentry/sveltekit';

/**
 * Logs an error to both console and Sentry
 *
 * @param componentName - The name of the component where the error occurred
 * @param error - The error object
 */
export function logComponentError(componentName: string, error: unknown): void {
  // Log to console
  console.error(`${componentName}:`, error);

  // Log to Sentry with component context
  Sentry.captureException(error, {
    tags: {
      component: componentName,
    },
  });
}
